window.$ = window.jQuery = require('jquery');

require('popper.js/dist/popper.min');
require('bootstrap/dist/js/bootstrap.min');

window.VGNav = require('vgnav/dist/js/vgnav.min');
window.AOS = require('aos/dist/aos');
require('vgformsender/dist/js/vgformsender.min');
require('vgscrollto/assets/js/jquery.vegasScrollTo');
require('vgsidebar/dist/js/vgsidebar');
require('vgloadmore/dist/jquery.vegas-loadMore');

require('@fancyapps/ui/dist/fancybox.esm');
require('inputmask/dist/inputmask');

require('../../vendor/modules/bg');
require('../../vendor/modules/carousel');
require('../../vendor/modules/modal');
require('../../vendor/modules/mask');
require('./modules/vegas');
require('./modules/ym');
require('./modules/catalog');
require('./functions');

// [[vegas]]
require('./custom');